import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { differenceInCalendarDays } from 'date-fns';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import data from 'src/assets/json/states.json';

import {
  NonAlcSitesTransactionType,
  ResponseStatus,
  TransactionsType,
  ValidationMessage,
} from '../../enum';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { paybevEnvironment } from 'src/environments/environment';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { forkJoin } from 'rxjs';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { ConfigService } from 'src/@services/config.service';

@Component({
  selector: 'app-add-update-supplier',
  templateUrl: './add-update-supplier.component.html',
  styleUrls: ['./add-update-supplier.component.scss'],

  standalone: false,
})
export class AddUpdateSupplierComponent {
  isVisibleSupplierModal = true;
  paybevEnvironmentUrl: any = paybevEnvironment.URL;
  @Output() hideSupplierModal = new EventEmitter();
  @Input() selectedSupplierData: any;

  today = new Date();
  todayDate = new FormControl(moment());

  currentUserEmail: any = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    .email;

  selectedData: any;
  tabIndex = 0;

  listOfSupplierTypes: any = [];
  listOfPaymentMethods: any = [];
  isLoadingData: boolean = true;
  assignmentContact: any;
  isLoadingAssignmentContact: boolean = false;

  url: any;
  isLoadingUpload = false;
  uploadResult: any;
  months: any = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  uploadedDocumentFile: any;
  documentFile: any;
  documentUpload: FormData = new FormData();
  usersList: any = [];
  listOfTerms: any = [];
  retailPrograms: any = [];
  canViewRetailProgram: boolean = false;
  canAddRetailProgram: boolean = false;
  canEditRetailProgram: boolean = false;
  isInternationalBrand: boolean = false;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService,
    private _iS: InnerPagesService,
    private _configS: ConfigService,
  ) {
    _fS.supplierDetailsForm_fb();
    _fS.supplierRequirementForm_fb();
  }
  listOfStates: any = data.States;
  disabledDate = (current: Date): boolean =>
    // Can not select days after today
    differenceInCalendarDays(current, this.today) > 0;

  // current.getTime() > this.today.getTime();
  ngOnInit(): void {
    this.isInternationalBrand = this._configS.isInternational();

    this.currentUserEmail = btoa(
      unescape(encodeURIComponent(this.currentUserEmail))
    );

    this._fS.supplierDetailsForm.patchValue({
      supplierName: this.selectedSupplierData?.companyName,
      agency: 'Supplier',
    });
    //disable supplier name and agency fields
    this._fS.supplierDetailsForm.get('supplierName')?.disable();
    this._fS.supplierDetailsForm.get('agency')?.disable();

    this.canViewRetailProgram = this._iS.canAccessRetailPrograms().canViewRetailPrograms;
    this.canAddRetailProgram = this._iS.canAccessRetailPrograms().canAddRetailPrograms;
    this.canEditRetailProgram = this._iS.canAccessRetailPrograms().canEditRetailPrograms;

    //get dropdwon records
    this.fetchDropdownData();
  }

  tabEvent(event: any) {
    this.tabIndex = event;
    if (event == 2 && this.retailPrograms?.length == 0) {
      this.isLoadingData = true;
      forkJoin([
        this._cpS.getRetailProgramForSupplier(),
        this._cpS.getRetailSupplierCodes(),
      ]).subscribe(([retailProgramsResponse, retailSupplierCodesResponse]: any) => {
        if (retailProgramsResponse.responseStatus == ResponseStatus.success) {
          this.retailPrograms = retailProgramsResponse.result;
        }
        if (
          retailSupplierCodesResponse.responseStatus == ResponseStatus.success
        ) {
          //find program with name wine.com
          const wineComProgram = this.retailPrograms.find(
            (program: any) => program.name.toLowerCase() === 'wine.com'
          );
          if (wineComProgram) {
            wineComProgram['codes'] =
              retailSupplierCodesResponse.result[0].codes;
          }

          //patch retail programs

          if (this.selectedSupplierData.retailPrograms) {
            this.retailPrograms.forEach((program: any) => {
              const supplierProgram = this.selectedSupplierData.retailPrograms.find(
                (supProgram: any) => supProgram.id === program.id
              );
              if (supplierProgram) {
                program['selectedCode'] = supplierProgram.code;
                program['isAssigned'] = true;
              } else {
                program['selectedCode'] = '';
              }
            });
          }
        }
        this.isLoadingData = false;
      });
    }
  }

  fetchDropdownData() {
    forkJoin([
      this._cpS.GetAllAccountTypesDropdown(2), // 2 is for supplier
      this._iS.getInternalUserDropdown(),
      this._cpS.getGenericPopulateRecords('1'), //
      this._cpS.getSupplierById(this.selectedSupplierData.id),
    ]).subscribe(
      ([
        supplierTypesResponse,
        usersResponse,
        termsResponse,
        supplierResponse,
      ]: any) => {
        if (supplierTypesResponse.responseStatus == ResponseStatus.success) {
          this.listOfSupplierTypes = supplierTypesResponse.result;
        }
        if (usersResponse.responseStatus == ResponseStatus.success) {
          this.usersList = usersResponse.result;
        }
        if (termsResponse.responseStatus == ResponseStatus.success) {
          this.listOfTerms = termsResponse.result.term;
          this.listOfPaymentMethods = termsResponse.result.paymentMethod;
        }
        this.isLoadingData = false;
        if (supplierResponse.responseStatus == ResponseStatus.success) {
          this.selectedSupplierData = supplierResponse.result;
          //patch data to form while edit
          this.patchDataToForm();
        } else {
          this._cS.displayMessage('error', supplierResponse.message);
        }
      }
    );
  }

  getSupplierDetails() {
    this._cpS
      .getSupplierById(this.selectedSupplierData.id)
      .subscribe((res: any) => {
        if (res.responseStatus == ResponseStatus.success) {
          this.selectedSupplierData = res.result;
          //patch data to form while edit
          this.patchDataToForm();
        } else {
          this._cS.displayMessage('error', res.message);
        }
      });
  }

  getsupplierTypes() {
    this._cpS.GetAllAccountTypesDropdown(2).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfSupplierTypes = response.result;
        //patch site type to form
        if (this.selectedSupplierData?.supplierTypeId) {
          this._fS.supplierDetailsForm.patchValue({
            supplierType: this.selectedSupplierData.supplierTypeId,
          });
        }
        //patch data to form while edit
        this.patchDataToForm();
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  patchDataToForm() {
    if (this.selectedSupplierData != null) {
      var selectedSupplierType = this.listOfSupplierTypes.find(
        (type: any) => type.id == this.selectedSupplierData?.supplierTypeId
      );
      //patchvalue to form while edit
      if (!this.listOfStates.includes(this.selectedSupplierData.state)) {
        this.listOfStates.push(this.selectedSupplierData.state);
      }

      this.uploadResult = this.selectedSupplierData.profileImageUrl;
      this.documentFile = this.selectedSupplierData.document;

      this._fS.supplierDetailsForm.patchValue({
        supplierName: this.selectedSupplierData.investorDisplayName,
        agency: 'Supplier',
        supplierType: selectedSupplierType ? selectedSupplierType.id : '',
        status: this.selectedSupplierData.isActive,
        nonAlcStatus: this.selectedSupplierData.isNonAlc,
        assignment: this.selectedSupplierData.assignment?.id,
        documentDate:
          !this.selectedSupplierData.documentDate ||
            this.selectedSupplierData.documentDate?.toString()?.includes('0001')
            ? ''
            : new Date(this.selectedSupplierData.documentDate),
      });
      // if (this.selectedSupplierData?.assignment?.id) {
      //   this.getAssignmentUserDetails();
      // }
      this._fS.supplierRequirementForm.patchValue({
        isInvoice: this.selectedSupplierData.isInvoice,
        terms: this.selectedSupplierData.terms?.id,
        paymentMethod: this.selectedSupplierData.paymentMethod?.id,
        fiscalStart: this.selectedSupplierData.fiscalStart,
        desc: this.selectedSupplierData.supplierDescription,
        notes: this.selectedSupplierData.supplierNotes,
      });
    }
  }

  // getAssignmentUserDetails() {
  //   if (this._fS.supplierDetailsForm.get('assignment').value) {
  //     this.isLoadingAssignmentContact = true;
  //     this._cpS
  //       .getUserDetails(this._fS.supplierDetailsForm.get('assignment').value)
  //       .subscribe((response: any) => {
  //         if (response.responseStatus == ResponseStatus.success) {
  //           this.assignmentContact = response.result;
  //         } else {
  //           this._cS.displayMessage('error', response.message);
  //         }
  //         this.isLoadingAssignmentContact = false;
  //       });
  //   } else {
  //     this.assignmentContact = null
  //   }
  // }

  handleChangeBulkUpload({ file }: NzUploadChangeParam) {
    if (file.status === 'uploading') {
      this.documentUpload = new FormData();
      this.uploadedDocumentFile = this.documentFile = file;

      //set contract date value to today date only if it is not set
      if (!this._fS.supplierDetailsForm.get('documentDate').value) {
        this._fS.supplierDetailsForm.patchValue({
          documentDate: new Date(),
        });
      }
      // set validators required for contract date field
      this._fS.supplierDetailsForm
        .get('documentDate')
        .setValidators([Validators.required]);
      this._fS.supplierDetailsForm.get('documentDate').updateValueAndValidity();

      // for (var i = 0; i < this.uploadedDocumentFile.length; i++) {
      this.documentUpload.set(
        'File',
        this.uploadedDocumentFile.originFileObj
          ? this.uploadedDocumentFile.originFileObj
          : this.uploadedDocumentFile.name
      );

      if (this.uploadedDocumentFile) {
        this._cpS
          .fileContractUpload(this.documentUpload)
          .subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.documentFile = response.result[0];
            }
          });
      }
    }
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    // do not allow more tham one file to be uploaded
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (isJpgOrPng) {
      this._cS.displayMessage('warning', 'You cannot upload JPG or PNG file!');
      return false;
    } else {
      return true;
    }
  };

  //cancel update role
  handleCancel(data?: any) {
    this.isVisibleSupplierModal = false;

    if (data) {
      this.hideSupplierModal.emit({
        hide: this.isVisibleSupplierModal,
        data: data,
      });
    } else {
      this.hideSupplierModal.emit({
        hide: this.isVisibleSupplierModal,
        data: null,
      });
    }
  }

  Onclick(e: any) {
    e.target.value = null;
  }
  onFileChanged(e: any) {
    let reader = new FileReader();
    if (
      e.target.files[0].length > 0 ||
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg' ||
      e.target.files[0].type === 'image/avif'
    ) {
      this.url = e.target.files[0];
      reader.readAsDataURL(this.url);
      reader.onload = () => {
        this.url = reader.result;
        this.isLoadingUpload = true;
        // this.isLoadingOne = true
        this._fS.fileupload.set('File', e.target.files[0]);
        this._fS.fileupload.set('Screen', 'SupplierProfile');

        this._cpS.fileUpload(this._fS.fileupload).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.uploadResult = response.result[0];
              this._cS.displayMessage('success', response.message);
              this.isLoadingUpload = false;
              // this.isLoadingOne = false
            } else {
              this._cS.displayMessage('error', response.message);
              this.isLoadingUpload = false;
              // this.isLoadingOne = false
            }
          },
          (error: any) => {
            // this._cS.displayMessage('error', error.message);
            this.isLoadingUpload = false;
            // this.isLoadingOne = false
          }
        );
      };
    } else {
      this.msg.error('File type is not allowed');
      this.url = null;
      this.uploadResult = null;
      this.isLoadingUpload = false;
      // this.isLoadingOne = false
    }
  }
  removeLogo() {
    var requestBody = {
      screen: 'SupplierProfile',
      filename: this.uploadResult,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.url = '';
        this.uploadResult = null;
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }
  removeFile() {
    var requestBody = {
      screen: 'Supplier',
      filename: this.documentFile.name,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        // this._cS.displayMessage('success', response.message);
        this.uploadedDocumentFile = null;
        this.documentFile = null;

        //reset contract date value to null
        this._fS.supplierDetailsForm.patchValue({
          documentDate: '',
        });
        // remove validators for contract date field
        this._fS.supplierDetailsForm.get('documentDate').clearValidators();
        this._fS.supplierDetailsForm
          .get('documentDate')
          .updateValueAndValidity();
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  setSupplierCodeToProgram(event: any, program: any) {
    program['selectedCode'] = event;
  }

  selectedSiteName: any;

  handleOk() {
    if (this._fS.supplierDetailsForm.valid) {
      const formValue = this._fS.supplierDetailsForm.value;
      const requirementFormValue = this._fS.supplierRequirementForm.value;
      //find name of selected site type
      var selectedSupplierType = this.listOfSupplierTypes?.find(
        (type: any) => type.id == formValue.supplierType
      );
      const retailProgramsArray: any = [];
      if (this.retailPrograms.length > 0) {
        this.retailPrograms.forEach((program: any) => {
          if (program['selectedCode']) {
            retailProgramsArray.push({
              id: program.id,
              name: program.name,
              code: program['selectedCode'],
            });
          }
        });
      }

      var supplierBody = {
        id: this.selectedSupplierData.id ? this.selectedSupplierData.id : '',
        profile: this.uploadResult,
        isActive: formValue.status,
        isNonAlc: formValue.nonAlcStatus,
        SupplierTypeId: formValue.supplierType,
        supplierTypeName: selectedSupplierType?.name,
        document: this.documentFile,
        documentDate: formValue.documentDate ? formValue.documentDate : '',
        fiscalStart: requirementFormValue.fiscalStart,
        description: requirementFormValue.desc,
        notes: requirementFormValue.notes,
        retailPrograms: retailProgramsArray,
        investorDisplayName: this.selectedSupplierData.investorDisplayName,
        assignment: formValue.assignment ? {
          id: formValue.assignment,
          name: formValue.assignment
            ? this.usersList.find(
              (user: any) => user.id == formValue.assignment
            )?.name
            : '',
        } : null,
        isInvoice: requirementFormValue.isInvoice,
        terms: {
          id: requirementFormValue.terms,
          name: requirementFormValue.terms
            ? this.listOfTerms.find(
              (term: any) => term.id == requirementFormValue.terms
            )?.name
            : '',
        },
        paymentMethod: requirementFormValue.paymentMethod ? {
          id: requirementFormValue.paymentMethod,
          name: requirementFormValue.paymentMethod
            ? this.listOfPaymentMethods?.find(
              (method: any) => method.id == requirementFormValue.paymentMethod
            )?.name
            : '',
        } : null,
      };

      //add or edit Account data

      this.updateSupplierData(supplierBody);
    } else {
      if (this.tabIndex != 0) {
        this._cS.displayMessage(
          'warning',
          'Please fill all the required fields in the Details tab.'
        );
      }
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.supplierDetailsForm);
    }
  }

  /**
   * Predicate function that only allows even numbers to be
   * sorted into even indices and odd numbers at odd indices.
   */

  isSavingSupplier = false;

  //api call to add/update Site
  updateSupplierData(supplierBody: any) {
    this.isSavingSupplier = true;
    this._iS.updateSupplierDetails(supplierBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);
        this.selectedSupplierData = response.result;

        this.handleCancel(this.selectedSupplierData);
        this.isSavingSupplier = false;
        this._cS.displayMessage('success', response.message);
      } else {
        this._cS.displayMessage('error', response.message);
        this.isSavingSupplier = false;
      }
    });
  }

  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }
}
